import * as React from 'react';

import { Spinner } from '@cian/ui-kit';

export const Loader: React.FC = () => {
  // inline-стили нужны для первого отображения
  const style: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
    zIndex: 1,
    backgroundColor: 'var(--white_60)',
  };

  return (
    <div style={style}>
      <Spinner />
    </div>
  );
};
